module.exports = __webpack_public_path__ + "img/air-freight@2x.718c6869.png";